import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deliveryField", "pickup"]

  selectDeliveryOption() {
    const operation = this.pickupTarget.checked ? "add" : "remove"
    this.deliveryFieldTargets.forEach(target => {
      target.disabled = this.pickupTarget.checked
      target.parentElement.classList[operation]("d-none")
    })
  }
}
